import React, { Component } from 'react';
import { AlternativeContact, CountriesData } from 'app-types';
import { isNil, get } from 'lodash-es';
import { ExternalLink, PhoneExternalLink, LabeledValue } from 'components';
import classNames from 'classnames';
import { getPhoneCodeByCountryId } from 'utils/utils';

interface Props {
	personalDetails: AlternativeContact;
	className?: string;
	title?: string;
	allCountries: CountriesData[];
	itemGridWidth?: number;
}

export class PersonalDetailsDisplay extends Component<Props> {
	getPhone = () => {
		const { personalDetails } = this.props;
		const { phoneCodeCountryId, phoneNumber } = personalDetails;
		const { allCountries } = this.props;
		if (isNil(phoneCodeCountryId) || isNil(phoneNumber) || isNil(allCountries)) {
			return null;
		}
		const phoneCode = getPhoneCodeByCountryId(allCountries, phoneCodeCountryId);
		return (
			<div className={this.getCSSClass()}>
				<LabeledValue
					label="Phone"
					value={<PhoneExternalLink phoneCode={phoneCode} phoneNumber={phoneNumber} />}
				/>
			</div>
		);
	};

	getName = () => {
		const { personalDetails } = this.props;
		const firstName = (get(personalDetails, 'firstName', '') || '').trim();
		const lastName = (get(personalDetails, 'lastName', '') || '').trim();

		return (
			<>
				<div className="modalBoxCol w2">
					<LabeledValue label="First name" value={firstName} />
				</div>
				<div className="modalBoxCol w2">
					<LabeledValue label="Last name" value={lastName} />
				</div>
			</>
		);
	};

	getCSSClass = (defaultItemGridWidth = 3) => {
		const { itemGridWidth } = this.props;
		let itemGrid = itemGridWidth || defaultItemGridWidth;

		return `modalBoxCol w${itemGrid}`;
	};

	render() {
		const { personalDetails, className, title } = this.props;

		if (!personalDetails) {
			return null;
		}

		return (
			<>
				<div className={classNames(className)}>
					{title && <h3>{title}</h3>}
					<div className="modalBoxLines">
						<div className="modalBoxRow modalBoxRowNested">
							{this.getName()}
							{this.getPhone()}
							{personalDetails.emailAddress && (
								<div className={this.getCSSClass(6)}>
									<LabeledValue
										label="Email address"
										value={
											<ExternalLink
												href={`mailto:${personalDetails.emailAddress}`}
												text={personalDetails.emailAddress}
											/>
										}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default PersonalDetailsDisplay;
